import * as React from 'react'

const CloseIcon = ({ color, ...rest }) => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg" {...rest}>
    <circle cx="10" cy="10" r="9.77778" transform="rotate(-90 10 10)" stroke="#1A0063" strokeWidth="0.444444" />
    <path
      d="M13.4094 5.95939L10.0002 9.36865L6.5909 5.95939C6.41655 5.78504 6.1339 5.78504 5.95955 5.95939C5.78521 6.13374 5.78521 6.41639 5.95955 6.59074L9.36882 10L5.95955 13.4093C5.78521 13.5836 5.78521 13.8663 5.95955 14.0406C6.1339 14.215 6.41655 14.215 6.5909 14.0406L10.0002 10.6313L13.4094 14.0406C13.5838 14.215 13.8664 14.215 14.0408 14.0406C14.2151 13.8663 14.2151 13.5836 14.0408 13.4093L10.6315 10L14.0408 6.59074C14.2151 6.41639 14.2151 6.13374 14.0408 5.95939C13.8664 5.78504 13.5838 5.78504 13.4094 5.95939Z"
      fill="#1A0063"
    />
  </svg>
)

export default CloseIcon
